<template>
  <div class="fillcontain">
    <div class="table_container">
      <el-row>
        <el-button type="primary" @click="handleEdit(0, '','add')">新增角色</el-button>
      </el-row>
      <br/>
      <el-table
        :data="tableData"
        style="width: 100%"
        v-loading="loading">
        <el-table-column
          label="角色名"
          prop="name">
        </el-table-column>
        <el-table-column
          label="权限"
          :show-overflow-tooltip="true"
          :formatter="permissionFormat">
        </el-table-column>
        <el-table-column label="操作" width="300">
          <template slot-scope="scope">
            <el-button
              size="mini"
              @click="handlePermissionEdit(scope.$index, scope.row)">
              设置权限
            </el-button>
            <el-button
              size="mini"
              @click="handleEdit(scope.$index, scope.row,'edit')">
              编辑
            </el-button>
            <el-button
              size="mini"
              type="danger"
              @click="handleDeleteAlert( scope.row)">
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-dialog :title="dialog.title" :visible.sync="dialog.dialogFormVisible" :close-on-click-modal="dialog.close">
        <el-form :model="role">
          <el-form-item label="角色名" label-width="100px">
            <el-input v-model="role.name" auto-complete="off" maxlength="20" show-word-limit></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialog.dialogFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="handleSave">确 定</el-button>
        </div>
      </el-dialog>

      <el-dialog  :title="dialog2.title" :visible.sync="dialog2.dialogFormVisible" :close-on-click-modal="dialog2.close">
        <div class="edit_dev">
          <el-transfer
            :titles="choosePermissionsTitles"
            :button-texts="['移除', '添加']"
            :format="{noChecked: '${total}',hasChecked: '${checked}/${total}'}"
            :right-default-checked="[60]"
            filterable
            :filter-method="filterMethod"
            filter-placeholder="请输入权限名"
            v-model="choosePermissions"
            :data="allPermissions"
            @change="handlePermissionChange"
            :props="{
            key: 'id',
            label: 'name'
          }"
          >
          </el-transfer>
        </div>
      </el-dialog>

    </div>
  </div>
</template>

<script>
  export default {
    data(){
      return {
        loading:false,
        role:{
          id:0,
          name:"",
        },
        dialog:{
          dialogFormVisible:false,
          title:"新增角色",
          close:false,
        },
        dialog2:{
          dialogFormVisible:false,
          title:"设置权限",
          close:false,
        },
        tableData: [],
        allPermissions: [],
        choosePermissions: [],
        choosePermissionsTitles:[],
        permissions:{
          id:0,
          name:"",
          typeName:"",
          apiPath:""
        },
        tmpRoleRow:null,
        filterMethod(query, item) {
          return item.name.indexOf(query) > -1;
        }
      }
    },
    created(){
      this.initData();

    },
    methods: {
      initData(){
        this.loading = true;
        var that = this;
        that.$api.get('/store/role', null, response => {
          if (response.status >= 200 && response.status < 300) {
            var res = response.data;
            if (res.code == 0) {
              that.tableData = res.data.role;
            }else{
              this.$message({
                message: res.msg,
                type: 'warning'
              });
            }
          } else {
            this.$message({
              message: "服务器维护中",
              type: 'error'
            });
          }
          this.loading = false;
        });
      },
      permissionData(hasChoosePermissions){
        var chooseIds = [];
        hasChoosePermissions.forEach(function(value,i){
          chooseIds.push(value.id);
        });
        this.loading = true;
        var that = this;
        that.allPermissions = [];
        that.choosePermissions = [];
        that.$api.get('/store/role/permissions', null, response => {
          if (response.status >= 200 && response.status < 300) {
            var res = response.data;
            if (res.code == 0) {
              that.allPermissions = res.data.sys_permissions;
              that.allPermissions.forEach(function(value,i){
                  value.name = value.typeName+"-"+value.name;
                   if(that.in_array(value.id,chooseIds)){
                     console.log("+"+value.id);
                     that.choosePermissions.push(value.id);
                   }
              });

              console.log("+"+that.choosePermissions);
            }else{
              this.$message({
                message: res.msg,
                type: 'warning'
              });
            }
          } else {
            this.$message({
              message: "服务器维护中",
              type: 'error'
            });
          }
          this.loading = false;
        });
      },
      in_array(search,array){
        for(var i in array){
          if(array[i]==search){
            return true;
          }
        }
        return false;
      },
      handlePermissionChange(value, direction, movedKeys){
          movedKeys = movedKeys.join(',');
          if (direction == "right") {
            this.handlePermissionsSave(movedKeys);
          } else {
            this.handlePermissionsDel(movedKeys)
          }
      },
      permissionFormat(row,column){
        var permissions = row['permissions'];
        if(permissions.length == 0){
          return "未设置";
        }else{
          var perNames = [];
          permissions.forEach(function(value,i){
            perNames.push(value.name);
          });

          return perNames.join('#');
        }

      },
      handlePermissionEdit(index, row) {
        this.permissions.id = row.id;
        this.permissions.name = row.name;
        this.permissions.typeName = row.typeName;
        this.permissions.apiPath = row.apiPath;
        this.choosePermissionsTitles=['未选权限',row.name+"的权限"];
        this.tmpRoleRow = row;
        this.permissionData(row.permissions);
        this.dialog2.dialogFormVisible = true;
      },
      handleEdit(index, row,action) {
        if(action == "edit"){
          this.dialog.title = "修改角色";
          this.role.id = row.id;
          this.role.name = row.name;
          this.dialog.dialogFormVisible = true;
        }else if(action == "add"){
          this.dialog.title = "增加角色";
          this.role.id = 0;
          this.role.name = "";
          this.dialog.dialogFormVisible = true;
        }
      },
      handleSave() {
        if(this.role.name == ''){
          this.$message({
            message: "名字不能为空",
            type: 'warning'
          });
          return;
        }
        this.loading = true;
        var that = this;
        that.$api.post('/store/role', that.role, response => {
          if (response.status >= 200 && response.status < 300) {
            console.log(response.data);
            var res = response.data;
            if (res.code == 0) {
              this.$message({
                message: that.dialog.title+'成功',
                type: 'success'
              });
              this.dialog.dialogFormVisible = false;
              this.initData();
            }else{
              this.$message({
                message: res.msg,
                type: 'warning'
              });
            }
          } else {
            this.$message({
              message: "服务器维护中",
              type: 'error'
            });
          }

        });

        this.loading = false;
      },
      handleDeleteAlert(row) {
        this.$confirm('此操作将删除该角色, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.handleDelete(row);
        }).catch(() => {

        });
      },
      handleDelete(row) {
        this.loading = true;
        var that = this;
        that.$api.delete('/store/role/'+row.id, null, response => {
          if (response.status >= 200 && response.status < 300) {
            console.log(response.data);
            var res = response.data;
            if (res.code == 0) {
              this.$message({
                message: '删除成功',
                type: 'success'
              });
              this.loading = false;
              this.initData();
            }else{
              this.$message({
                message: res.msg,
                type: 'warning'
              });
            }
          } else {
            this.$message({
              message: "服务器维护中",
              type: 'error'
            });
          }

        });
        this.loading = false;
      },

      handlePermissionsSave(ids) {

        this.loading = true;
        var that = this;
        that.$api.post('/store/role/'+that.permissions.id+'/permissions/'+ids, null, response => {
          if (response.status >= 200 && response.status < 300) {
            console.log(response.data);
            var res = response.data;
            if (res.code == 0) {
                console.log("权限设置成功")
                that.tmpRoleRow.permissions = res.data.role.permissions;
            }else{
              this.$message({
                message: res.msg,
                type: 'warning'
              });
            }
          } else {
            this.$message({
              message: "服务器维护中",
              type: 'error'
            });
          }

        });

        this.loading = false;
      },
      handlePermissionsDel(ids) {

        this.loading = true;
        var that = this;
        that.$api.delete('/store/role/'+that.permissions.id+'/permissions/'+ids, null, response => {
          if (response.status >= 200 && response.status < 300) {
            console.log(response.data);
            var res = response.data;
            if (res.code == 0) {
              console.log("权限删除成功")
              that.tmpRoleRow.permissions = res.data.role.permissions;
            }else{
              this.$message({
                message: res.msg,
                type: 'warning'
              });
            }
          } else {
            this.$message({
              message: "服务器维护中",
              type: 'error'
            });
          }

        });

        this.loading = false;
      },
    },
  }
</script>

<style lang="less">
  @import '../../style/mixin';
  .demo-table-expand {
    font-size: 0;
  }
  .demo-table-expand label {
    width: 90px;
    color: #99a9bf;
  }
  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
  }
  .table_container{
    padding: 20px;
    text-align: left;
  }
  .Pagination{
    display: flex;
    justify-content: flex-start;
    margin-top: 8px;
  }
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #20a0ff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 120px;
    height: 120px;
    line-height: 120px;
    text-align: center;
  }
  .avatar {
    width: 120px;
    height: 120px;
    display: block;
  }
</style>
<style scoped>
  .edit_dev >>> .el-transfer-panel {
    width:350px;
  }

</style>





// WEBPACK FOOTER //
// src/pages/store/Roles.vue